<template>
  <el-container class="export-test-paper">
    <el-header>
      <h2>导出试卷</h2>
    </el-header>
    <el-container>
      <el-aside width="156px">
        <h3>试卷结构调整</h3>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="A"></el-checkbox>
          <el-checkbox label="B"></el-checkbox>
          <el-checkbox label="大题评分区"></el-checkbox>
          <el-checkbox label="禁用"></el-checkbox>
          <el-checkbox label="选中"></el-checkbox>
        </el-checkbox-group>
      </el-aside>
      <el-main>Main</el-main>
    </el-container>
    <el-footer>
      <DsfButton>保存</DsfButton>
      <DsfButton>取消</DsfButton>
      <DsfButton>导出试卷</DsfButton>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "ExportTestPaper",
  components: {
  },
  data() {
    return {
      checkList: ['选中且禁用','复选框 A']
      
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style></style>
